// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"G0-z","subtitle":"H0-z","wrapper":"I0-z","leftArrow":"J0-z","rightArrow":"K0-z"};